import { TextField as MuiTextField, TextFieldProps } from '@mui/material';
import { forwardRef } from 'react';

type TTextFieldProps = TextFieldProps & {
  rtl?: boolean;
  children?: any;
  helperText?: any;
};

export const TextField = forwardRef<HTMLDivElement, TTextFieldProps>(
  ({ children, rtl, sx, ...other }, ref) => {
    return (
      <MuiTextField
        {...other}
        ref={ref}
        sx={{
          ...sx,
          ...(rtl && {
            '& label': {
              transformOrigin: 'top right',
              right: 28,
              left: 'auto',
            },
            '& legend': {
              textAlign: 'right',
            },
            '& .MuiFormHelperText-root': {
              textAlign: 'right',
            },
          }),
        }}
      >
        {children}
      </MuiTextField>
    );
  },
);
